import { useState, useEffect } from 'react';
import { formatTimeAgo } from '../lib/timeAgo';

/** Live-updating relative time display, e.g. "just now" -> "1m ago" -> "2h ago". */
export default function TimeAgo({ date }: { date: Date | string | null | undefined }) {
  const [text, setText] = useState(() => formatTimeAgo(date));

  useEffect(() => {
    const update = () => setText(formatTimeAgo(date));
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [date]);

  return <span>{text}</span>;
}
